import { useContext } from "react";
import { BRAND_PATTERNS, DEFAULT_BRAND_PATTERN_INDEX, type BrandPattern } from "@/constants/brandPattern";
import {
  BrandPatternContext,
  type BrandPatternContextValue,
} from "@/context/BrandPatternContext";

export function useBrandPattern(): BrandPatternContextValue {
  const ctx = useContext(BrandPatternContext);
  if (ctx == null) {
    return {
      patternIndex: DEFAULT_BRAND_PATTERN_INDEX,
      setPatternIndex: () => {
        /* no-op: Provider 外（Storybook 等） */
      },
      pattern: BRAND_PATTERNS[DEFAULT_BRAND_PATTERN_INDEX] as BrandPattern,
    };
  }
  return ctx;
}

export type { BrandPatternContextValue };
